import { mapActions } from "vuex";

import { getGeoType } from "@/helpers/utils";

export default {
  methods: {
    ...mapActions(["clearError", "setError", "fetchResults"]),
    async fetchData() {
      this.loading = true;
      const asyncForEach = async (array, callback) => {
        for (let index = 0; index < array.length; index++) {
          await callback(array[index], index, array);
        }
      };

      try {
        if (this.params.s3Path) {
          this.results = await this.fetchResults({
            s3Path: this.params.s3Path.trim(),
            detailedResults: this.params.detailedResults,
            params: this.params,
          });
        } else {
          const tempResults = [];
          const raceIds = this.params.raceIds.replace(/\s/, "").split(",");
          await asyncForEach(raceIds, async (id) => {
            tempResults.push(
              await this.fetchResults({
                id: id,
                s3Path: null,
                detailedResults: this.params.detailedResults,
                params: this.params,
              })
            );
          });
          this.results = tempResults.sort((a, b) =>
            a.full_title.localeCompare(b.full_title, undefined, { numeric: true })
          );
        }
        this.clearError();
      } catch (err) {
        this.setError(err);
      }
      this.geoType = getGeoType(this.selectedResult?.state_name);
      this.loading = false;
      return this.results;
    },
  },
  data() {
    return {
      geoType: null,
      loading: false,
      results: [],
    };
  },
};
